import { getQueryString } from 'app/lib/utils/search-params'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const useNextUrl = () => {
  const { search } = useLocation()

  const nextUrl = useMemo(() => getQueryString(search, 'next_url') || '', [search])

  return { nextUrl }
}
